module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('nav-bar'), _vm._v(" "), _c('div', {
    staticClass: "sidebar col-2 bg-darkgrey navbar-inverse side-box-shadow"
  }, [_c('ul', {
    staticClass: "nav flex-column"
  }, [(!_vm.$route.query.archive) ? _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link navbar-text pull-left",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.openModification()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('OrderInfo.sidebar.modification')))])]) : _vm._e(), _vm._v(" "), (!_vm.$route.query.archive) ? _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link navbar-text pull-left",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.openDispatch()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('OrderInfo.sidebar.dispatch')))])]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link navbar-text pull-left",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.openInspection()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('OrderInfo.sidebar.inspection')))])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link navbar-text pull-left",
    attrs: {
      "href": _vm.originalOrder.invoice,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.$t('OrderInfo.sidebar.purchase')))])]), _vm._v(" "), (!_vm.$route.query.archive) ? _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link navbar-text pull-left",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.openSend()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('OrderInfo.sidebar.send')))])]) : _vm._e(), _vm._v(" "), (!_vm.$route.query.archive) ? _c('li', {
    staticClass: "nav-item"
  }, [_c('span', {
    staticClass: "navbar-text pull-left pl-3"
  }, [_vm._v(_vm._s(_vm.$t('OrderInfo.sidebar.statusChange')))]), _vm._v(" "), _c('select', {
    staticClass: "form-control",
    domProps: {
      "value": _vm.originalOrder.status
    },
    on: {
      "change": function($event) {
        _vm.changeStatus($event.target.value)
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "Dispatch"
    }
  }, [_vm._v(_vm._s(_vm.$t('Search.status.dispatch')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Processing"
    }
  }, [_vm._v(_vm._s(_vm.$t('Search.status.processing')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Pick"
    }
  }, [_vm._v(_vm._s(_vm.$t('Search.status.pick')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Attente"
    }
  }, [_vm._v(_vm._s(_vm.$t('Search.status.waiting')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Transit"
    }
  }, [_vm._v(_vm._s(_vm.$t('Search.status.transit')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Drop"
    }
  }, [_vm._v(_vm._s(_vm.$t('Search.status.drop')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Cancel"
    }
  }, [_vm._v(_vm._s(_vm.$t('Search.status.canceled')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Terminée"
    }
  }, [_vm._v(_vm._s(_vm.$t('Search.status.finished')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Transférée"
    }
  }, [_vm._v(_vm._s(_vm.$t('Search.status.transfered')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Reject"
    }
  }, [_vm._v(_vm._s(_vm.$t('Search.status.rejected')))])])]) : _vm._e(), _vm._v(" "), (!_vm.$route.query.archive) ? _c('button', {
    staticClass: "btn btn-kne-orange col-12 mt-3 text-left",
    attrs: {
      "id": "chat"
    },
    on: {
      "click": function($event) {
        _vm.openNote()
      }
    }
  }, [_vm._v("\n         " + _vm._s(_vm.$t('OrderInfo.sidebar.chat')) + "\n         "), (_vm.notes.length > 0) ? _c('span', {
    staticClass: "pull-right badge btn-badge badge-default"
  }, [_vm._v(_vm._s(_vm.notes.length))]) : _vm._e()]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-10 offset-2 pt-3 px-0"
  }, [_c('div', {
    staticClass: "col-12 mb-3"
  }, [_c('div', {
    staticClass: "card",
    attrs: {
      "id": "location"
    }
  }, [_c('v-map', {
    attrs: {
      "zoom": 12,
      "center": [_vm.order.latitude, _vm.order.longitude]
    }
  }, [_c('v-tilelayer', {
    attrs: {
      "url": "http://{s}.tile.osm.org/{z}/{x}/{y}.png"
    }
  }), _vm._v(" "), _c('v-marker', {
    attrs: {
      "lat-lng": [_vm.order.latitude, _vm.order.longitude]
    }
  })], 1)], 1)]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.history.length > 0) ? _c('div', {
    staticClass: "col-12 mb-3"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h3', {
    staticClass: "my-3"
  }, [_vm._v(_vm._s(_vm.$t('OrderInfo.delivery.title')))])]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-hover font-grey mb-0"
  }, [_c('thead', {
    staticClass: "bg-darkgrey"
  }, [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t('OrderInfo.delivery.order')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('OrderInfo.delivery.driver')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('OrderInfo.delivery.date')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('OrderInfo.delivery.pickup')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('OrderInfo.delivery.delivery')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('OrderInfo.delivery.pickTime')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('OrderInfo.delivery.dropTime')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('OrderInfo.delivery.reference')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('OrderInfo.delivery.price')))]), _vm._v(" "), _c('th')])]), _vm._v(" "), _c('transition-group', {
    attrs: {
      "name": "fade",
      "tag": "tbody"
    }
  }, _vm._l((_vm.history), function(entry, key, index) {
    return _c('tr', {
      key: entry['.key']
    }, [_c('td', [_vm._v(_vm._s(entry['.key']))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(entry.chauffeurName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(entry.dateDispatch))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(entry.transmitterName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(entry.receiverName))]), _vm._v(" "), (entry.pickDate) ? _c('td', [_vm._v(_vm._s(_vm.getDate(entry.pickDate)))]) : _c('td'), _vm._v(" "), (entry.dropDate) ? _c('td', [_vm._v(_vm._s(_vm.getDate(entry.dropDate)))]) : _c('td'), _vm._v(" "), _c('td', [_vm._v(_vm._s(entry.numRef))]), _vm._v(" "), (entry.prix) ? _c('td', [_vm._v(_vm._s(((parseFloat(entry.prix)).toLocaleString('fr-CA', {
      style: 'currency',
      currency: 'CAD'
    }))))]) : _c('td'), _vm._v(" "), _c('td', [(!_vm.$route.query.archive) ? _c('input', {
      staticClass: "btn btn-kne-orange pull-right",
      attrs: {
        "type": "button",
        "value": _vm.$t('OrderInfo.delivery.modify')
      },
      on: {
        "click": function($event) {
          _vm.openModificationDelivery(entry)
        }
      }
    }) : _vm._e()])])
  }))], 1)])])]) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.preview) ? _c('modal', {
    attrs: {
      "closableBackdrop": "",
      "closable": ""
    },
    on: {
      "close-request": function($event) {
        _vm.close()
      }
    }
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": _vm.previewImgUrl
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.previewId))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.previewName))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.previewComment))])])]) : _vm._e(), _vm._v(" "), (_vm.chat || _vm.modify || _vm.modifyDelivery || _vm.dispatch || _vm.inspection || _vm.send) ? _c('modal', {
    attrs: {
      "closable": ""
    },
    on: {
      "close-request": function($event) {
        _vm.close()
      }
    }
  }, [(_vm.modify) ? _c('div', [_c('h3', {
    staticClass: "text-center"
  }, [_vm._v("Modification")]), _vm._v(" "), _c('div', {
    staticClass: "tab-content row"
  }, [_c('div', {
    staticClass: "mt-3 col-4 pr-0",
    attrs: {
      "id": "pickup",
      "role": ""
    }
  }, [_c('h4', {
    staticClass: "mx-3 kne-title"
  }, [_vm._v(_vm._s(_vm.$t('OrderInfo.modal.pickup.title')))]), _vm._v(" "), _c('regular-datalist', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.datalist.pickup,
      "originalList": _vm.$store.state.allContacts,
      "secondList": _vm.addressbook,
      "placeholder": _vm.$t('AddressBook.title')
    },
    on: {
      "input": function($event) {
        _vm.setAndSearch($event, 'pickup')
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.order.transmitterName,
      "type": "text",
      "placeholder": _vm.$t('OrderPending.pickupDeliveryTab.name') + '*'
    },
    on: {
      "input": function($event) {
        _vm.order.transmitterName = $event
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.order.transmitterAddress,
      "type": "text",
      "placeholder": _vm.$t('OrderPending.pickupDeliveryTab.address') + '*'
    },
    on: {
      "input": function($event) {
        _vm.order.transmitterAddress = $event
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.order.transmitterCity,
      "type": "text",
      "placeholder": _vm.$t('OrderPending.pickupDeliveryTab.city')
    },
    on: {
      "input": function($event) {
        _vm.order.transmitterCity = $event
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.order.transmitterPostcode,
      "type": "text",
      "placeholder": _vm.$t('OrderPending.pickupDeliveryTab.postal_code')
    },
    on: {
      "input": function($event) {
        _vm.order.transmitterPostcode = $event
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.order.transmitterProvince,
      "type": "text",
      "placeholder": _vm.$t('OrderPending.pickupDeliveryTab.province')
    },
    on: {
      "input": function($event) {
        _vm.order.transmitterProvince = $event
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.order.transmitterCountry,
      "type": "text",
      "placeholder": _vm.$t('OrderPending.pickupDeliveryTab.country')
    },
    on: {
      "input": function($event) {
        _vm.order.transmitterCountry = $event
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.order.transmitterEmail,
      "type": "text",
      "placeholder": _vm.$t('OrderPending.pickupDeliveryTab.email')
    },
    on: {
      "input": function($event) {
        _vm.order.transmitterEmail = $event
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.order.transmitterPhone,
      "type": "tel",
      "placeholder": _vm.$t('OrderPending.pickupDeliveryTab.phone')
    },
    on: {
      "input": function($event) {
        _vm.order.transmitterPhone = $event
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.order.transmitterFax,
      "type": "tel",
      "placeholder": _vm.$t('OrderPending.pickupDeliveryTab.fax')
    },
    on: {
      "input": function($event) {
        _vm.order.transmitterFax = $event
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.order.transmitterContact,
      "type": "text",
      "placeholder": _vm.$t('OrderPending.pickupDeliveryTab.contact')
    },
    on: {
      "input": function($event) {
        _vm.order.transmitterContact = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "mt-3 col-4 px-0",
    attrs: {
      "id": "delivery"
    }
  }, [_c('h4', {
    staticClass: "mx-3 kne-title"
  }, [_vm._v(_vm._s(_vm.$t('OrderInfo.modal.delivery.title')))]), _vm._v(" "), _c('regular-datalist', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.datalist.delivery,
      "originalList": _vm.$store.state.allContacts,
      "secondList": _vm.addressbook,
      "placeholder": _vm.$t('AddressBook.title')
    },
    on: {
      "input": function($event) {
        _vm.setAndSearch($event, 'delivery')
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.order.receiverName,
      "type": "text",
      "placeholder": _vm.$t('OrderPending.pickupDeliveryTab.name') + '*'
    },
    on: {
      "input": function($event) {
        _vm.order.receiverName = $event
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.order.receiverAddress,
      "type": "text",
      "placeholder": _vm.$t('OrderPending.pickupDeliveryTab.address') + '*'
    },
    on: {
      "input": function($event) {
        _vm.order.receiverAddress = $event
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.order.receiverCity,
      "type": "text",
      "placeholder": _vm.$t('OrderPending.pickupDeliveryTab.city')
    },
    on: {
      "input": function($event) {
        _vm.order.receiverCity = $event
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.order.receiverPostcode,
      "type": "text",
      "placeholder": _vm.$t('OrderPending.pickupDeliveryTab.postal_code')
    },
    on: {
      "input": function($event) {
        _vm.order.receiverPostcode = $event
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.order.receiverProvince,
      "type": "text",
      "placeholder": _vm.$t('OrderPending.pickupDeliveryTab.province')
    },
    on: {
      "input": function($event) {
        _vm.order.receiverProvince = $event
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.order.receiverCountry,
      "type": "text",
      "placeholder": _vm.$t('OrderPending.pickupDeliveryTab.country')
    },
    on: {
      "input": function($event) {
        _vm.order.receiverCountry = $event
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.order.receiverEmail,
      "type": "text",
      "placeholder": _vm.$t('OrderPending.pickupDeliveryTab.email')
    },
    on: {
      "input": function($event) {
        _vm.order.receiverEmail = $event
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.order.receiverPhone,
      "type": "tel",
      "placeholder": _vm.$t('OrderPending.pickupDeliveryTab.phone')
    },
    on: {
      "input": function($event) {
        _vm.order.receiverPhone = $event
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.order.receiverFax,
      "type": "tel",
      "placeholder": _vm.$t('OrderPending.pickupDeliveryTab.fax')
    },
    on: {
      "input": function($event) {
        _vm.order.receiverFax = $event
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.order.receiverContact,
      "type": "text",
      "placeholder": _vm.$t('OrderPending.pickupDeliveryTab.contact')
    },
    on: {
      "input": function($event) {
        _vm.order.receiverContact = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "mt-3 col-4 pl-0",
    attrs: {
      "id": "billing"
    }
  }, [_c('h4', {
    staticClass: "mx-3 kne-title"
  }, [_vm._v(_vm._s(_vm.$t('OrderInfo.modal.billing.title')))]), _vm._v(" "), _c('regular-datalist', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.datalist.billing,
      "originalList": _vm.$store.state.allContacts,
      "secondList": _vm.addressbook,
      "placeholder": _vm.$t('AddressBook.title')
    },
    on: {
      "input": function($event) {
        _vm.setAndSearch($event, 'billing')
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.order.payerName,
      "type": "text",
      "placeholder": _vm.$t('OrderPending.pickupDeliveryTab.name') + '*'
    },
    on: {
      "input": function($event) {
        _vm.order.payerName = $event
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.order.payerAddress,
      "type": "text",
      "placeholder": _vm.$t('OrderPending.pickupDeliveryTab.address') + '*'
    },
    on: {
      "input": function($event) {
        _vm.order.payerAddress = $event
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.order.payerCity,
      "type": "text",
      "placeholder": _vm.$t('OrderPending.pickupDeliveryTab.city')
    },
    on: {
      "input": function($event) {
        _vm.order.payerCity = $event
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.order.payerPostcode,
      "type": "text",
      "placeholder": _vm.$t('OrderPending.pickupDeliveryTab.postal_code')
    },
    on: {
      "input": function($event) {
        _vm.order.payerPostcode = $event
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.order.payerProvince,
      "type": "text",
      "placeholder": _vm.$t('OrderPending.pickupDeliveryTab.province')
    },
    on: {
      "input": function($event) {
        _vm.order.payerProvince = $event
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.order.payerCountry,
      "type": "text",
      "placeholder": _vm.$t('OrderPending.pickupDeliveryTab.country')
    },
    on: {
      "input": function($event) {
        _vm.order.payerCountry = $event
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.order.payerEmail,
      "type": "text",
      "placeholder": _vm.$t('OrderPending.pickupDeliveryTab.email')
    },
    on: {
      "input": function($event) {
        _vm.order.payerEmail = $event
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.order.payerPhone,
      "type": "tel",
      "placeholder": _vm.$t('OrderPending.pickupDeliveryTab.phone')
    },
    on: {
      "input": function($event) {
        _vm.order.payerPhone = $event
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.order.payerFax,
      "type": "tel",
      "placeholder": _vm.$t('OrderPending.pickupDeliveryTab.fax')
    },
    on: {
      "input": function($event) {
        _vm.order.payerFax = $event
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.order.payerContact,
      "type": "text",
      "placeholder": _vm.$t('OrderPending.pickupDeliveryTab.contact')
    },
    on: {
      "input": function($event) {
        _vm.order.payerContact = $event
      }
    }
  })], 1)]), _vm._v(" "), _c('h4', {
    staticClass: "mx-3 kne-title"
  }, [_vm._v("Information")]), _vm._v(" "), _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row pt-4"
  }, [_c('regular-input', {
    staticClass: "col-12 col-sm-6 form-group",
    attrs: {
      "value": _vm.order.numRef,
      "type": "text",
      "placeholder": _vm.$t('OrderInfo.modal.reference')
    },
    on: {
      "input": function($event) {
        _vm.order.numRef = $event
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 col-sm-6 form-group",
    attrs: {
      "value": _vm.order.price,
      "type": "number",
      "placeholder": _vm.$t('OrderInfo.modal.price')
    },
    on: {
      "input": function($event) {
        _vm.order.price = $event
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 col-sm-6 form-group",
    attrs: {
      "value": _vm.order.vin,
      "type": "text",
      "placeholder": _vm.$t('OrderInfo.modal.VIN')
    },
    on: {
      "input": function($event) {
        _vm.order.vin = $event
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 col-sm-6 form-group",
    attrs: {
      "value": _vm.order.year,
      "type": "number",
      "placeholder": _vm.$t('OrderInfo.modal.year')
    },
    on: {
      "input": function($event) {
        _vm.order.year = $event
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 col-sm-6 form-group",
    attrs: {
      "value": _vm.order.make,
      "type": "text",
      "placeholder": _vm.$t('OrderInfo.modal.make')
    },
    on: {
      "input": function($event) {
        _vm.order.make = $event
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 col-sm-6 form-group",
    attrs: {
      "value": _vm.order.model,
      "type": "text",
      "placeholder": _vm.$t('OrderInfo.modal.model')
    },
    on: {
      "input": function($event) {
        _vm.order.model = $event
      }
    }
  }), _vm._v(" "), _c('regular-textarea', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.order.comment,
      "placeholder": _vm.$t('OrderInfo.modal.comment'),
      "rows": "6"
    },
    on: {
      "input": function($event) {
        _vm.order.comment = $event
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {}, [_c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.order.datePromis,
      "type": "date",
      "placeholder": _vm.$t('OrderPending.orderTab.datePromis')
    },
    on: {
      "input": function($event) {
        _vm.order.datePromis = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('button', {
    staticClass: "btn btn-kne-orange w-100 form-group",
    attrs: {
      "disabled": !_vm.formCompleted
    },
    on: {
      "click": function($event) {
        _vm.modifyOrder()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('OrderInfo.modal.modify')))])]), _vm._v(" "), _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('regular-select', {
    staticClass: "col-12 col-sm-6 form-group",
    attrs: {
      "value": _vm.taxes,
      "placeholder": _vm.$t('OrderInfo.modal.tax')
    },
    on: {
      "change": function($event) {
        _vm.taxes = $event
      }
    }
  }, _vm._l((_vm.$store.state.provinces), function(province) {
    return _c('option', {
      domProps: {
        "value": province
      }
    }, [_vm._v(_vm._s(province))])
  })), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 col-sm-6 form-group",
    attrs: {
      "value": _vm.order.billingDate,
      "type": "date",
      "placeholder": _vm.$t('OrderInfo.modal.date')
    },
    on: {
      "input": function($event) {
        _vm.order.billingDate = _vm.formatDate($event)
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('regular-textarea', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.taxesComment,
      "placeholder": _vm.$t('OrderInfo.modal.taxesComment'),
      "rows": "6"
    },
    on: {
      "input": function($event) {
        _vm.taxesComment = $event
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": 'https://mysageone.ca.sageone.com/oauth2/auth?response_type=code&client_id=3ff1477e6ec457b7df62&redirect_uri=https://systems.keepneye.com/api4/SageoneToken&scope=full_access&transpuid=' + _vm.companyUID + '&commandid=' + _vm.$route.query.orderId
    }
  }, [_c('button', {
    staticClass: "btn btn-kne-orange w-100",
    attrs: {
      "disabled": _vm.taxes === '' || !_vm.order.sageID || _vm.order.price === '' || _vm.order.billingDate === ''
    },
    on: {
      "click": function($event) {
        _vm.modifyOrder()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('OrderInfo.modal.billing.title')))])])])]) : _vm._e(), _vm._v(" "), (_vm.inspection) ? _c('div', [_c('h3', {
    staticClass: "kne-title mx-3"
  }, [_vm._v("Inspection")]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('regular-select', {
    staticClass: "col-12 col-sm-6 form-group",
    attrs: {
      "value": _vm.inspectionOrder.key,
      "placeholder": _vm.$t('OrderInfo.modal.choose')
    },
    on: {
      "change": function($event) {
        _vm.inspectionOrder.key = $event
      }
    }
  }, _vm._l((_vm.history), function(order) {
    return _c('option', [_vm._v(_vm._s(order['.key']))])
  })), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-sm-6"
  }, [_c('button', {
    staticClass: "btn btn-kne-orange w-100 form-group",
    attrs: {
      "disabled": !_vm.orderChosen
    },
    on: {
      "click": function($event) {
        _vm.generate()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('OrderInfo.modal.generate')))])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('regular-input', {
    staticClass: "col-12 col-sm-6",
    attrs: {
      "value": _vm.inspectionOrder.email,
      "type": "text",
      "placeholder": _vm.$t('OrderInfo.modal.email')
    },
    on: {
      "input": function($event) {
        _vm.inspectionOrder.email = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-sm-6"
  }, [_c('button', {
    staticClass: "btn btn-kne-orange w-100 form-group",
    attrs: {
      "disabled": !_vm.emailEntered
    },
    on: {
      "click": function($event) {
        _vm.sendBolTo()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('OrderInfo.modal.BOL')))])]), _vm._v(" "), _c('div', {
    staticClass: "ml-auto col-sm-6"
  }, [_c('button', {
    staticClass: "btn btn-kne-orange w-100 form-group",
    on: {
      "click": function($event) {
        _vm.mergeBody()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('OrderInfo.modal.merge')))])])], 1)])]) : _vm._e(), _vm._v(" "), (_vm.dispatch || _vm.send) ? _c('div', [(_vm.dispatch) ? _c('h3', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.$t('OrderInfo.sidebar.dispatch')))]) : _c('h3', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.$t('OrderInfo.sidebar.send')))]), _vm._v(" "), _c('div', {
    staticClass: " pt-4"
  }, [(_vm.dispatch) ? _c('regular-datalist-driver', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.dispatchOrder.chauffeurName,
      "secondList": _vm.listOrdered,
      "placeholder": _vm.$t('OrderInfo.modal.driver')
    },
    on: {
      "input": function($event) {
        _vm.dispatchOrder.chauffeurName = $event.value;
        _vm.dispatchOrder.chauffeur = $event.key
      }
    }
  }) : _c('regular-select', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.sendOrder.carrier,
      "placeholder": _vm.$t('OrderInfo.modal.carrier')
    },
    on: {
      "change": function($event) {
        _vm.sendOrder.carrier = $event
      }
    }
  }, _vm._l((_vm.carriersOrdered), function(c) {
    return _c('option', {
      domProps: {
        "value": c['.key']
      }
    }, [_vm._v(_vm._s(c['.value']))])
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "tab-content row"
  }, [_c('div', {
    staticClass: "mt-3 col-6 pr-0",
    attrs: {
      "id": "pickup"
    }
  }, [_c('h4', {
    staticClass: "mx-3 kne-title"
  }, [_vm._v(_vm._s(_vm.$t('OrderInfo.modal.pickup.title')))]), _vm._v(" "), _c('regular-datalist', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.datalist.pickup,
      "originalList": _vm.$store.state.allContacts,
      "secondList": _vm.addressbook,
      "placeholder": _vm.$t('AddressBook.title')
    },
    on: {
      "input": function($event) {
        _vm.setAndSearch($event, 'pickup')
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.order.transmitterName,
      "type": "text",
      "placeholder": _vm.$t('OrderPending.pickupDeliveryTab.name') + '*'
    },
    on: {
      "input": function($event) {
        _vm.order.transmitterName = $event
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.order.transmitterAddress,
      "type": "text",
      "placeholder": _vm.$t('OrderPending.pickupDeliveryTab.address') + '*'
    },
    on: {
      "input": function($event) {
        _vm.order.transmitterAddress = $event
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.order.transmitterCity,
      "type": "text",
      "placeholder": _vm.$t('OrderPending.pickupDeliveryTab.city')
    },
    on: {
      "input": function($event) {
        _vm.order.transmitterCity = $event
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.order.transmitterPostcode,
      "type": "text",
      "placeholder": _vm.$t('OrderPending.pickupDeliveryTab.postal_code')
    },
    on: {
      "input": function($event) {
        _vm.order.transmitterPostcode = $event
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.order.transmitterProvince,
      "type": "text",
      "placeholder": _vm.$t('OrderPending.pickupDeliveryTab.province')
    },
    on: {
      "input": function($event) {
        _vm.order.transmitterProvince = $event
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.order.transmitterCountry,
      "type": "text",
      "placeholder": _vm.$t('OrderPending.pickupDeliveryTab.country')
    },
    on: {
      "input": function($event) {
        _vm.order.transmitterCountry = $event
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.order.transmitterEmail,
      "type": "text",
      "placeholder": _vm.$t('OrderPending.pickupDeliveryTab.email')
    },
    on: {
      "input": function($event) {
        _vm.order.transmitterEmail = $event
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.order.transmitterPhone,
      "type": "tel",
      "placeholder": _vm.$t('OrderPending.pickupDeliveryTab.phone')
    },
    on: {
      "input": function($event) {
        _vm.order.transmitterPhone = $event
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.order.transmitterFax,
      "type": "tel",
      "placeholder": _vm.$t('OrderPending.pickupDeliveryTab.fax')
    },
    on: {
      "input": function($event) {
        _vm.order.transmitterFax = $event
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.order.transmitterContact,
      "type": "text",
      "placeholder": _vm.$t('OrderPending.pickupDeliveryTab.contact')
    },
    on: {
      "input": function($event) {
        _vm.order.transmitterContact = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "mt-3 col-6 pl-0",
    attrs: {
      "id": "delivery"
    }
  }, [_c('h4', {
    staticClass: "mx-3 kne-title"
  }, [_vm._v(_vm._s(_vm.$t('OrderInfo.modal.delivery.title')))]), _vm._v(" "), _c('regular-datalist', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.datalist.delivery,
      "originalList": _vm.$store.state.allContacts,
      "secondList": _vm.addressbook,
      "placeholder": _vm.$t('AddressBook.title')
    },
    on: {
      "input": function($event) {
        _vm.setAndSearch($event, 'delivery')
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.order.receiverName,
      "type": "text",
      "placeholder": _vm.$t('OrderPending.pickupDeliveryTab.name') + '*'
    },
    on: {
      "input": function($event) {
        _vm.order.receiverName = $event
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.order.receiverAddress,
      "type": "text",
      "placeholder": _vm.$t('OrderPending.pickupDeliveryTab.address') + '*'
    },
    on: {
      "input": function($event) {
        _vm.order.receiverAddress = $event
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.order.receiverCity,
      "type": "text",
      "placeholder": _vm.$t('OrderPending.pickupDeliveryTab.city')
    },
    on: {
      "input": function($event) {
        _vm.order.receiverCity = $event
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.order.receiverPostcode,
      "type": "text",
      "placeholder": _vm.$t('OrderPending.pickupDeliveryTab.postal_code')
    },
    on: {
      "input": function($event) {
        _vm.order.receiverPostcode = $event
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.order.receiverProvince,
      "type": "text",
      "placeholder": _vm.$t('OrderPending.pickupDeliveryTab.province')
    },
    on: {
      "input": function($event) {
        _vm.order.receiverProvince = $event
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.order.receiverCountry,
      "type": "text",
      "placeholder": _vm.$t('OrderPending.pickupDeliveryTab.country')
    },
    on: {
      "input": function($event) {
        _vm.order.receiverCountry = $event
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.order.receiverEmail,
      "type": "text",
      "placeholder": _vm.$t('OrderPending.pickupDeliveryTab.email')
    },
    on: {
      "input": function($event) {
        _vm.order.receiverEmail = $event
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.order.receiverPhone,
      "type": "tel",
      "placeholder": _vm.$t('OrderPending.pickupDeliveryTab.phone')
    },
    on: {
      "input": function($event) {
        _vm.order.receiverPhone = $event
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.order.receiverFax,
      "type": "tel",
      "placeholder": _vm.$t('OrderPending.pickupDeliveryTab.fax')
    },
    on: {
      "input": function($event) {
        _vm.order.receiverFax = $event
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.order.receiverContact,
      "type": "text",
      "placeholder": _vm.$t('OrderPending.pickupDeliveryTab.contact')
    },
    on: {
      "input": function($event) {
        _vm.order.receiverContact = $event
      }
    }
  })], 1)]), _vm._v(" "), _c('h4', {
    staticClass: "mx-3 kne-title"
  }, [_vm._v("Information")]), _vm._v(" "), _c('div', {
    staticClass: " pt-4"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('regular-input', {
    staticClass: "col-12 col-sm-6 form-group",
    attrs: {
      "value": _vm.order.numRef,
      "type": "text",
      "placeholder": _vm.$t('OrderInfo.modal.reference')
    },
    on: {
      "input": function($event) {
        _vm.order.numRef = $event
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 col-sm-6 form-group",
    attrs: {
      "value": _vm.order.price,
      "type": "number",
      "placeholder": _vm.$t('OrderInfo.modal.price')
    },
    on: {
      "input": function($event) {
        _vm.order.price = $event
      }
    }
  }), _vm._v(" "), _c('regular-textarea', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.order.comment,
      "placeholder": _vm.$t('OrderInfo.modal.comment'),
      "rows": "6"
    },
    on: {
      "input": function($event) {
        _vm.order.comment = $event
      }
    }
  })], 1), _vm._v(" "), (_vm.dispatch) ? _c('button', {
    staticClass: "btn btn-kne-orange w-100",
    attrs: {
      "disabled": !_vm.dispatchFormFilled
    },
    on: {
      "click": function($event) {
        _vm.dispatchAction()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('OrderInfo.modal.dispatch')))]) : _c('button', {
    staticClass: "btn btn-kne-orange w-100",
    attrs: {
      "disabled": !_vm.sendFormFilled
    },
    on: {
      "click": function($event) {
        _vm.sendAction()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('OrderInfo.modal.send')))])])])]) : _vm._e(), _vm._v(" "), (_vm.chat) ? _c('div', [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('h3', {
    staticClass: "font-grey kne-title"
  }, [_vm._v(_vm._s(_vm.$t('Dashboard.new_note_title')))]), _vm._v(" "), _c('regular-textarea', {
    staticClass: "p-2",
    attrs: {
      "value": _vm.note.text,
      "placeholder": _vm.$t('Dashboard.new_note_message'),
      "rows": "4"
    },
    on: {
      "input": function($event) {
        _vm.note.text = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container pb-2"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('regular-input', {
    staticClass: "col-12 col-md-6 pl-2 pr-1",
    attrs: {
      "value": _vm.note.name,
      "placeholder": _vm.$t('Dashboard.new_note_name')
    },
    on: {
      "input": function($event) {
        _vm.note.name = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-md-6 pr-2 pl-1"
  }, [_c('button', {
    staticClass: "btn btn-kne-orange w-100",
    attrs: {
      "disabled": !_vm.noteFilled
    },
    on: {
      "click": function($event) {
        _vm.sendNote()
      }
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$t('General.send')) + "\n                  ")])])], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [_c('h3', {
    staticClass: "font-grey kne-title"
  }, [_vm._v(_vm._s(_vm.$t('Dashboard.notes_title')))]), _vm._v(" "), _c('transition-group', {
    attrs: {
      "name": "fade",
      "tag": "div"
    }
  }, _vm._l((_vm.reversedNotes), function(n) {
    return _c('div', {
      key: n['.key'],
      staticClass: "card-block p-3 message",
      attrs: {
        "data-toggle": "collapse",
        "data-parent": "#accordion",
        "href": '#collapse' + n['.key'],
        "aria-expanded": "true",
        "aria-controls": '#collapse' + n['.key']
      }
    }, [_c('div', {
      staticClass: "collapse",
      attrs: {
        "id": 'collapse' + n['.key'],
        "role": "tabpanel",
        "aria-labelledby": "headingOne"
      }
    }, [_c('p', {
      staticClass: "text-justify"
    }, [_vm._v(_vm._s(n.text))])]), _vm._v(" "), _c('p', {
      staticClass: "header font-grey"
    }, [_c('i', [_vm._v(_vm._s(n.name))]), _vm._v(" "), _c('i', {
      staticClass: "pull-right"
    }, [_vm._v(_vm._s(_vm.getDate(n.date)))])])])
  }))], 1)])])]) : _vm._e(), _vm._v(" "), (_vm.modifyDelivery) ? _c('div', [_c('h4', {
    staticClass: "kne-title mx-3"
  }, [_vm._v("Modification")]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('regular-input', {
    staticClass: "col-12 col-sm-6 form-group",
    attrs: {
      "value": _vm.order.numRef,
      "type": "text",
      "placeholder": _vm.$t('OrderInfo.modal.reference')
    },
    on: {
      "input": function($event) {
        _vm.order.numRef = $event
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 col-sm-6 form-group",
    attrs: {
      "value": _vm.order.price,
      "type": "number",
      "placeholder": _vm.$t('OrderInfo.modal.price')
    },
    on: {
      "input": function($event) {
        _vm.order.price = $event
      }
    }
  }), _vm._v(" "), _c('regular-textarea', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.order.comment,
      "placeholder": _vm.$t('OrderInfo.modal.comment'),
      "rows": "6"
    },
    on: {
      "input": function($event) {
        _vm.order.comment = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-sm-6"
  }, [_c('button', {
    staticClass: "btn btn-kne-orange w-100 mb-3",
    on: {
      "click": function($event) {
        _vm.modifyDeliveryAction()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('OrderInfo.modal.save')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-sm-6"
  }, [_c('a', {
    attrs: {
      "href": _vm.deliveryInvoice,
      "target": "_blank"
    }
  }, [_c('button', {
    staticClass: "btn btn-kne-orange w-100 mb-3",
    on: {
      "click": function($event) {}
    }
  }, [_vm._v(_vm._s(_vm.$t('OrderInfo.modal.purchase')))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-sm-6"
  }, [_c('button', {
    staticClass: "btn btn-kne-orange w-100",
    on: {
      "click": function($event) {
        _vm.resend()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('OrderInfo.modal.resend')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-sm-6"
  }, [_c('button', {
    staticClass: "btn btn-kne-orange w-100",
    on: {
      "click": function($event) {
        _vm.regenerate()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('OrderInfo.modal.regenerate')))])])], 1)])]) : _vm._e()]) : _vm._e()], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.originalOrder.isTransfered && _vm.originalOrder.idTransfer) ? _c('div', {
    staticClass: "col-12 my-3"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h3', {
    staticClass: "my-3"
  }, [_vm._v(_vm._s(_vm.$t('OrderInfo.transfered.title')))])]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-hover font-grey mb-0"
  }, [_c('thead', {
    staticClass: "bg-darkgrey"
  }, [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t('OrderInfo.transfered.carrier')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('OrderInfo.transfered.reference')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('OrderInfo.transfered.order')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('OrderInfo.transfered.VIN')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('OrderInfo.transfered.date')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('OrderInfo.transfered.pickup')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('OrderInfo.transfered.delivery')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('OrderInfo.transfered.status')))]), _vm._v(" "), (_vm.originalOrder.priceTransfered) ? _c('th', [_vm._v(_vm._s(_vm.$t('OrderInfo.transfered.refTransfer')))]) : _vm._e(), _vm._v(" "), (_vm.originalOrder.refTransfered) ? _c('th', [_vm._v(_vm._s(_vm.$t('OrderInfo.transfered.priceTransfer')))]) : _vm._e()])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v(_vm._s(_vm.transfer.transpName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.transfer.orderRef))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.transfer['.key']))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.transfer.vin))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getDate(_vm.transfer.creationDate)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.transfer.transmitterName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.transfer.receiverName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.transfer.status))]), _vm._v(" "), (_vm.originalOrder.refTransfered) ? _c('td', [_vm._v(_vm._s(_vm.originalOrder.refTransfered))]) : _vm._e(), _vm._v(" "), (_vm.originalOrder.priceTransfered) ? _c('td', [_vm._v(_vm._s(_vm.originalOrder.priceTransfered))]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('regular-input', {
    staticClass: "col-12 col-sm-4",
    attrs: {
      "value": _vm.modifyTransfer.refTransfered,
      "type": "text",
      "placeholder": _vm.$t('OrderInfo.transfered.refTransfer')
    },
    on: {
      "input": function($event) {
        _vm.modifyTransfer.refTransfered = $event
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 col-sm-4",
    attrs: {
      "value": _vm.modifyTransfer.priceTransfered,
      "type": "number",
      "placeholder": _vm.$t('OrderInfo.transfered.priceTransfer')
    },
    on: {
      "input": function($event) {
        _vm.modifyTransfer.priceTransfered = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('button', {
    staticClass: "btn btn-kne-orange w-100",
    on: {
      "click": function($event) {
        _vm.modifyTransferAction()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('OrderInfo.transfered.confirm')))])])], 1)])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "info"
    }
  }, [_c('div', {
    staticClass: "col-12 col-lg-4 mb-3"
  }, [_c('div', {
    staticClass: "card font-grey"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "info pt-3 pb-4"
  }, [_c('p', {
    staticClass: "card-text"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('OrderInfo.information.status')))]), _vm._v(" "), (_vm.originalOrder.status === 'Dispatch') ? _c('span', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.$t('Search.status.dispatch')))]) : _vm._e(), _vm._v(" "), (_vm.originalOrder.status === 'Processing') ? _c('span', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.$t('Search.status.processing')))]) : _vm._e(), _vm._v(" "), (_vm.originalOrder.status === 'Pick') ? _c('span', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.$t('Search.status.pick')))]) : _vm._e(), _vm._v(" "), (_vm.originalOrder.status === 'Attente') ? _c('span', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.$t('Search.status.waiting')))]) : _vm._e(), _vm._v(" "), (_vm.originalOrder.status === 'Transit') ? _c('span', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.$t('Search.status.transit')))]) : _vm._e(), _vm._v(" "), (_vm.originalOrder.status === 'Drop') ? _c('span', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.$t('Search.status.drop')))]) : _vm._e(), _vm._v(" "), (_vm.originalOrder.status === 'Cancel') ? _c('span', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.$t('Search.status.canceled')))]) : _vm._e(), _vm._v(" "), (_vm.originalOrder.status === 'Terminée') ? _c('span', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.$t('Search.status.finished')))]) : _vm._e(), _vm._v(" "), (_vm.originalOrder.status === 'Transférée') ? _c('span', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.$t('Search.status.transfered')))]) : _vm._e(), _vm._v(" "), (_vm.originalOrder.status === 'Reject') ? _c('span', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.$t('Search.status.rejected')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "info pt-3 pb-4"
  }, [_c('p', {
    staticClass: "card-text"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('OrderInfo.information.order')))]), _c('span', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.originalOrder['.key']))])])]), _vm._v(" "), _c('div', {
    staticClass: "info pt-3 pb-4"
  }, [_c('p', {
    staticClass: "card-text"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('OrderInfo.information.creationDate')))]), _c('span', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.getDate(_vm.originalOrder.creationDate)))])])]), _vm._v(" "), _c('div', {
    staticClass: "info pt-3 pb-4"
  }, [_c('p', {
    staticClass: "card-text"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('OrderInfo.information.VIN')))]), _c('span', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.originalOrder.vin))])])]), _vm._v(" "), _c('div', {
    staticClass: "info pt-3 pb-4"
  }, [_c('p', {
    staticClass: "card-text"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('OrderInfo.information.year')))]), _c('span', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.originalOrder.year))])])]), _vm._v(" "), _c('div', {
    staticClass: "info pt-3 pb-4"
  }, [_c('p', {
    staticClass: "card-text"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('OrderInfo.information.make')))]), _c('span', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.originalOrder.make))])])]), _vm._v(" "), _c('div', {
    staticClass: "info pt-3 pb-4"
  }, [_c('p', {
    staticClass: "card-text"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('OrderInfo.information.model')))]), _c('span', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.originalOrder.model))])])]), _vm._v(" "), _c('div', {
    staticClass: "info pt-3 pb-4"
  }, [_c('p', {
    staticClass: "card-text"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('OrderInfo.information.pickup')))]), _c('span', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.originalOrder.transmitterName))])])]), _vm._v(" "), _c('div', {
    staticClass: "info pt-3 pb-4"
  }, [_c('p', {
    staticClass: "card-text"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('OrderInfo.information.delivery')))]), _c('span', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.originalOrder.receiverName))])])]), _vm._v(" "), _c('div', {
    staticClass: "info pt-3 pb-4"
  }, [_c('p', {
    staticClass: "card-text"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('OrderInfo.information.billing')))]), _c('span', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.originalOrder.payerName))])])]), _vm._v(" "), _c('div', {
    staticClass: "info pt-3 pb-4"
  }, [_c('p', {
    staticClass: "card-text"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('OrderInfo.information.price')))]), _vm._v(" "), (_vm.originalOrder.price) ? _c('span', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(((parseFloat(_vm.originalOrder.price)).toLocaleString('fr-CA', {
    style: 'currency',
    currency: 'CAD'
  }))))]) : _c('span')])]), _vm._v(" "), _c('div', {
    staticClass: "info pt-3 pb-4"
  }, [_c('p', {
    staticClass: "card-text"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('OrderInfo.information.reference')))]), _c('span', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.originalOrder.numRef))])])]), _vm._v(" "), _c('div', {
    staticClass: "info pt-3 pb-4"
  }, [_c('p', {
    staticClass: "card-text"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('Facture')))]), _c('span', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.originalOrder.billNum))])])]), _vm._v(" "), _c('div', {
    staticClass: "info pt-3 pb-4"
  }, [_c('p', {
    staticClass: "card-text"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('OrderInfo.information.comment')))]), _c('span', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.originalOrder.comment))])])]), _vm._v(" "), _c('div', {
    staticClass: "info pt-3 pb-4"
  }, [_c('p', {
    staticClass: "card-text"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('OrderInfo.information.keys')))]), _c('span', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.originalOrder.nbKey))])])]), _vm._v(" "), _c('div', {
    staticClass: "info pt-3 pb-4"
  }, [_c('p', {
    staticClass: "card-text"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('OrderInfo.information.trackingCode')))]), _c('span', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.originalOrder.codeSecret))])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-lg-8"
  }, [_c('div', {
    staticClass: "card font-grey"
  }, [_c('div', {
    staticClass: "card-block p-1"
  }, [_c('h5', {
    staticClass: "text-center pt-4"
  }, [_vm._v(_vm._s(_vm.$t('OrderInfo.photos')))]), _vm._v(" "), _vm._l((_vm.order.photos), function(photoUrl) {
    return _c('img', {
      staticClass: "m-1 img-fluid mini",
      attrs: {
        "src": photoUrl
      },
      on: {
        "click": function($event) {
          _vm.openPreview($event.target.currentSrc)
        }
      }
    })
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "card-block p-1"
  }, [_c('h5', {
    staticClass: "text-center pt-4"
  }, [_vm._v(_vm._s(_vm.$t('OrderInfo.bodyPhotos')))]), _vm._v(" "), _vm._l((_vm.order.bodyPhotos), function(photoUrl) {
    return _c('img', {
      staticClass: "m-1 img-fluid mini",
      attrs: {
        "src": photoUrl
      },
      on: {
        "click": function($event) {
          _vm.openPreview($event.target.currentSrc)
        }
      }
    })
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "card-block p-1"
  }, [_c('h5', {
    staticClass: "text-center pt-4"
  }, [_vm._v(_vm._s(_vm.$t('OrderInfo.signaturePhotos')))]), _vm._v(" "), _vm._l((_vm.history), function(entry) {
    return _c('img', {
      staticClass: "m-1 img-fluid mini",
      attrs: {
        "src": entry.pickSignature
      },
      on: {
        "click": function($event) {
          _vm.openPreview($event.target.currentSrc, entry.pickName, entry.nightPickComment, entry['.key'])
        }
      }
    })
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "card-block p-1"
  }, [_c('h5', {
    staticClass: "text-center pt-4"
  }, [_vm._v(_vm._s(_vm.$t('OrderInfo.signatureDrop')))]), _vm._v(" "), _vm._l((_vm.history), function(entry) {
    return _c('img', {
      staticClass: "m-1 img-fluid mini",
      attrs: {
        "src": entry.dropSignature
      },
      on: {
        "click": function($event) {
          _vm.openPreview($event.target.currentSrc, entry.dropName, entry.nightDropComment, entry['.key'])
        }
      }
    })
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "card-block p-1"
  }, [_c('h5', {
    staticClass: "text-center pt-4"
  }, [_vm._v(_vm._s(_vm.$t('OrderInfo.dropPhotos')))]), _vm._v(" "), _vm._l((_vm.history), function(dispatch) {
    return _c('div', [_vm._l((dispatch.dropPhotos), function(entry) {
      return _c('img', {
        staticClass: "m-1 img-fluid mini",
        attrs: {
          "src": entry
        },
        on: {
          "click": function($event) {
            _vm.openPreview($event.target.currentSrc)
          }
        }
      })
    }), _vm._v(" "), _c('p', {
      staticClass: "text-center"
    }, [_vm._v("\n                " + _vm._s(_vm.history.nightDropComment) + "\n              ")])], 2)
  })], 2)])])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2c998b1e","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/view/OrderInfo.vue
// module id = 830
// module chunks = 1